import { useTranslation } from 'react-i18next';
import { LoadingIndicator } from '@unified-checkout/design-system';
import styles from './full-page-loader.module.scss';

export const FullPageLoader = () => {
  const { t } = useTranslation();

  return (
    <div className={styles['full-page-loader']}>
      <LoadingIndicator
        size='lg'
        text={t('loading')}
      />
    </div>
  )
}